const ATTRIBUTION_PARAMS = [
    'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'utm_id',
    'gclid', 'gbraid', 'wbraid', 'gad_source', 'gad_campaignid',
];
const GCLID_DAYS = 90;

/** utm_params go with the payment (orders_attribution); the Ads upload matches the click by the gclid cookie, for 90 days. */
export function saveAttribution() {
    try {
        storeAttribution();
    } catch (e) {
        console.warn('attribution not saved', e);
    }
}

function storeAttribution() {
    const query = new URLSearchParams(window.location.search);
    const found = {};
    ATTRIBUTION_PARAMS.forEach(function (name) {
        const value = query.get(name);
        if (value) {
            found[name] = value;
        }
    });
    if (!Object.keys(found).length) {
        return;
    }

    // The cookie first: storage that is blocked throws, and the click id matters more.
    if (found.gclid) {
        document.cookie = 'gclid=' + encodeURIComponent(found.gclid) + '; max-age=' + GCLID_DAYS * 86400
            + '; path=/; SameSite=Lax' + (window.location.protocol === 'https:' ? '; Secure' : '');
    }

    found.timestamp = Date.now();
    found.referrer = document.referrer;
    localStorage.setItem('utm_params', JSON.stringify(found));
}

/** Same shape as the events the server queues (site.analytics-events). */
export function track(event, params) {
    // Called on the way to a payment or an error message, which a broken data layer must not stop.
    try {
        window.dataLayer = window.dataLayer || [];
        // GTM merges every push into one model, so the previous event's parameters would carry over.
        window.dataLayer.push({event_params: null, ecommerce: null});
        window.dataLayer.push({event: event, event_params: params || {}});
    } catch (e) {
        console.warn('analytics event not tracked', event, e);
    }
}

export function planType(packet) {
    if (!packet) {
        return undefined;
    }
    if (!packet.is_subscription) {
        return 'single';
    }

    return Number(packet.trial_amount) > 0 ? 'trial' : 'subscription';
}
